// Mock data for Luka Nozza Guest Entertainer Landing Page

export const mockData = {
  hero: {
    name: "LUKA NOZZA",
    tagline: "LIVE MUSIC FOR AN UNFORGETTABLE NIGHT",
    description: "Powerhouse vocalist, instrumentalist, and producer with nearly two decades of international stage experience",
    ctaText: "Book Luka Nozza",
    backgroundVideo: "https://customer-assets.emergentagent.com/job_elegant-host/artifacts/fi8qwgnv_Website%20.mov"
  },

  about: {
    title: "About Luka",
    bio: "Luka Nozza is a powerhouse vocalist, instrumentalist, and producer with nearly two decades of international stage experience. He has performed for global brands such as Google, Deutsche Bank, and eBay, and has performed extensively across Europe and the US. A graduate of the Jazz Academy in Freiburg, Germany, Luka has released four studio albums and earned public recognition after appearing on The Voice of Germany (Season 8).",
    credentials: [
      "20 Years International Stage Experience",
      "Graduate of Jazz Academy, Freiburg",
      "Featured on The Voice of Germany Season 8",
      "Four Studio Albums Released"
    ]
  },

  shows: [
    {
      id: 1,
      title: "RETRO REWIND",
      description: "THE PERFECT BLEND OF NOSTALGIC HITS. SOME EVERYONE KNOWS, OTHERS ARE SONGS THAT LIVE IN CHILDHOOD MEMORIES, MUSIC WORTH LIVING FOR.",
      image: "https://customer-assets.emergentagent.com/job_elegant-host/artifacts/xd1oyfgw_Screenshot%202025-12-07%20at%2009.53.56.png",
      features: ["Classic Hits", "Nostalgic Favorites", "Timeless Melodies"]
    },
    {
      id: 2,
      title: "FUSION FANTASY",
      description: "SOMETIMES MUSIC BECOMES NOISE. BUT THE MIX OF SONGS IN THIS SHOW ALWAYS SPARKS JOY, CAPTURING BOTH THE AUDIENCE'S ATTENTION AND THEIR HEARTS.",
      image: "https://customer-assets.emergentagent.com/job_elegant-host/artifacts/wl1e9v4h_Screenshot%202025-11-07%20at%2020.24.27.png",
      features: ["Contemporary Mix", "Joyful Energy", "Captivating Performance"]
    }
  ],

  sizeGuide: [
    {
      id: 1,
      title: "Intimate Events",
      guestCount: "Up to 50 guests",
      duration: "2-3 hours",
      venues: ["Private Residences", "Boutique Venues", "Garden Parties"],
      description: "Perfect for exclusive gatherings where personal connection matters"
    },
    {
      id: 2,
      title: "Medium Events",
      guestCount: "50-200 guests",
      duration: "3-4 hours",
      venues: ["Corporate Functions", "Wedding Receptions", "Gala Dinners"],
      description: "Ideal for sophisticated celebrations with refined entertainment"
    },
    {
      id: 3,
      title: "Large Events",
      guestCount: "200+ guests",
      duration: "4-5 hours",
      venues: ["Conference Halls", "Hotel Ballrooms", "Festival Stages"],
      description: "Spectacular performances for grand occasions and large audiences"
    }
  ],

  testimonials: [
    {
      id: 1,
      quote: "WORDS AREN'T ENOUGH, A TRULY REMARKABLE PERFORMER.",
      author: "Cuba Gooding Jr.",
      role: "Hollywood Actor"
    },
    {
      id: 2,
      quote: "AN INSPIRING PERSONALITY WITH EXCEPTIONAL TALENT, HE AMAZED AND ENTERTAINED US THE ENTIRE EVENING.",
      author: "Deutsche Bank",
      role: "Regional Foundation"
    },
    {
      id: 3,
      quote: "THE MUSIC WAS INCREDIBLE, THE SINGER OUTSTANDING. WE'RE ALREADY PLANNING TO BOOK HIM AGAIN NEXT YEAR.",
      author: "Google",
      role: "Zurich Branch"
    }
  ],

  brands: [
    { name: "Google", logo: "Google" },
    { name: "Deutsche Bank", logo: "Deutsche Bank" },
    { name: "eBay", logo: "eBay" }
  ],

  contact: {
    email: "Lukanozza@gmail.com",
    phone: "+995 568 87 87 98",
    socialMedia: {
      instagram: "https://www.instagram.com/lukanozza",
      spotify: "https://open.spotify.com/artist/5H405Bwizmov4OuIU7vHt8?si=2zE9h100SNaQcWVTVyKh4Q",
      facebook: "#",
      youtube: "https://youtu.be/B4GC1ECm3OM?si=a8LuyV9Js0DV1FKk"
    }
  },

  chatResponses: [
    "Hello! I'm here to help you book Luka Nozza for your event. What type of event are you planning?",
    "Thank you for your interest! What date did you have in mind?",
    "Perfect! I'll prepare a custom quote for your event. Can you provide your email address?",
    "Excellent! Someone from our team will be in touch within 24 hours with all the details."
  ]
};